// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const AdminLogin = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="min-h-screen flex items-center justify-center bg-white">
//       <div className="bg-slate-200 p-8 rounded-lg shadow-lg w-full max-w-sm">
//         <img 
//           src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png" 
//           alt="Logo" 
//           className="w-full mb-6"
//         />
//         <div className="space-y-4">
//           <input 
//             type="text" 
//             placeholder="Username" 
//             className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"
//           />
//           <input 
//             type="password" 
//             placeholder="Password" 
//             className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"
//           />
//           <button 
//             className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-600 transition-colors duration-300"
//             onClick={() => navigate('/AdminPortal')}
//           >
//             Login
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLogin;
import React from "react";
import { login } from "../../Auth/auth";

const AdminLogin = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="bg-slate-200 p-8 rounded-lg shadow-lg w-full max-w-sm">
        <img
          src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png"
          alt="Logo"
          className="w-full mb-6"
        />

        <button
          className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
          onClick={login}
        >
          Sign in as Admin
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;